import { Button, Col, Row } from "react-bootstrap";
import {
  DashLg,
  Key,
  PlusLg,
  StoplightsFill,
  Vinyl
} from "react-bootstrap-icons";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { MapKeysProps } from "interfaces/components/Map/MapKeysProps";
import ActiveVehicle from "../../assets/map/keys/activevehiclekey.png";
import HwrcSite from "../../assets/map/keys/hwrcsitekey.png";
import DisposalSite from "../../assets/map/keys/disposalsitekey.png";

const MapKeys = ({
  position,
  handleRecenterMap,
  handleZoomIn,
  handleZoomOut,
  handleTrafficToggle
}: MapKeysProps) => {
  const [showKey, setShowKey] = useState(false);

  const onShowKey = () => {
    setShowKey(!showKey);
  };

  switch (position) {
    case google.maps.ControlPosition.RIGHT_BOTTOM:
      return (
        <>
          <div>
            <Button
              variant={showKey ? "secondary" : "primary"}
              className="bi-list-ul p-0 custom-map-controls-right last-map-control"
              aria-label="key"
              data-tooltip-id="vehicle-map-key"
              data-testid="vehicle-map-key"
              onClick={onShowKey}
              id="vehicle-map-key-button"
            >
              <Key size={30} />
            </Button>
            <Tooltip
              id="vehicle-map-key"
              place="left"
              isOpen={showKey}
              variant="light"
              className="vehicle-key-tooltip"
            >
              <aside>
                <Row className="align-items-center">
                  <Col xs="auto">
                    <img
                      data-testid="vehicle-map-key-active"
                      src={ActiveVehicle}
                      alt="Active vehicle pin key"
                    />
                  </Col>
                  <Col xs="auto">
                    <span>Active</span>
                  </Col>
                  <Col xs="auto">
                    <img
                      data-testid="vehicle-map-key-hwrcsite"
                      src={HwrcSite}
                      alt="Hwrc Site pin key"
                    />
                  </Col>
                  <Col xs="auto">
                    <span>HWRC</span>
                  </Col>
                  <Col xs="auto">
                    <img
                      data-testid="vehicle-map-key-disposalsite"
                      src={DisposalSite}
                      alt="Disposal Site pin key"
                    />
                  </Col>
                  <Col xs="auto">
                    <span>Disposal</span>
                  </Col>
                </Row>
              </aside>
            </Tooltip>

            <Tooltip id="vehicle-map-key" content="Vehicle key" place="left" />
          </div>
        </>
      );
    case google.maps.ControlPosition.LEFT_BOTTOM:
      return (
        <>
          <div>
            <Button
              variant="primary"
              onClick={handleZoomIn}
              className="bi-list-ul p-0 custom-map-controls-left"
              aria-label="Zoom in"
              data-tooltip-id="map-zoom-in"
              data-testid="map-zoom-in"
            >
              <PlusLg size={30} />
            </Button>
            <Tooltip id="map-zoom-in" content="Zoom in" place="right" />
          </div>
          <div>
            <Button
              variant="primary"
              onClick={handleZoomOut}
              className="bi-list-ul p-0 custom-map-controls-left"
              aria-label="Zoom out"
              data-tooltip-id="map-zoom-out"
              data-testid="map-zoom-out"
            >
              <DashLg size={30} />
            </Button>
            <Tooltip id="map-zoom-out" content="Zoom out" place="right" />
          </div>
          <div>
            <Button
              variant="primary"
              onClick={handleRecenterMap}
              className="bi-list-ul p-0 custom-map-controls-left"
              aria-label="Recenter"
              data-tooltip-id="map-recenter"
              data-testid="map-recenter"
            >
              <Vinyl size={30} />
            </Button>
            <Tooltip id="map-recenter" content="Recenter" place="right" />
          </div>
          <div>
            <Button
              variant="primary"
              onClick={handleTrafficToggle}
              className="bi-list-ul p-0 custom-map-controls-left"
              aria-label="traffic button"
              data-tooltip-id="map-traffic"
              data-testid="map-traffic"
            >
              <StoplightsFill size={30} />
            </Button>
            <Tooltip
              id="map-traffic"
              content="Traffic Information"
              place="right"
            />
          </div>
        </>
      );
    default:
      return <></>;
  }
};

export default MapKeys;
